import { render, staticRenderFns } from "./userCenterPage.vue?vue&type=template&id=7fb9cc8a&scoped=true"
import script from "./userCenterPage.vue?vue&type=script&lang=js"
export * from "./userCenterPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/userCenterPage.scss?vue&type=style&index=0&id=7fb9cc8a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb9cc8a",
  null
  
)

export default component.exports